<template>
  <div class="creatMessage-box">
    <p class="title">短信配置&nbsp;&nbsp;<strong>[ 短信模板 ]</strong></p>
    <tips></tips>
    <div class="addBtn">
      <el-button type="primary" style="padding:8px 12px" @click="creatMessage">
        <i class="el-icon-circle-plus"></i>&nbsp;创建模板
      </el-button>
    </div>
     <el-table :data="messageData" border>
      <el-table-column label="模板编号" prop="mouldSign"></el-table-column>
      <!-- <el-table-column label="通道编号" prop="platformNum"></el-table-column> -->
      
      <el-table-column label="模板名称" prop="mouldName"></el-table-column>
      <el-table-column label="模板内容" prop="mouldContent"></el-table-column>
      <el-table-column label="模板类型" width="90">
        <template slot-scope="scope">
          <p v-if="scope.row.mouldTypeId == 0">普通短信</p>
          <p v-else>营销短信</p>
        </template>
      </el-table-column>
      <el-table-column label="是否公用">
        <template slot-scope="scope">
          <p>{{scope.row.isPublic?'公用':'不公用'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="90">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isAuditing == 0">通过</el-tag>
          <el-tag type="warning" v-else-if="scope.row.isAuditing == 1">审核中</el-tag>
          <el-tag type="info" v-else>拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="模板申请原因" prop="mouldReason"></el-table-column>
      <el-table-column label="审核失败原因" prop="reason"></el-table-column>
      <!-- <el-table-column label="用户名称"  prop="userName"></el-table-column>
      <el-table-column label="用户电话"  prop="userPhone"></el-table-column> -->
      <el-table-column label="创建时间" prop="createtimeStr"></el-table-column>
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <span class="text-blue pointer" @click="sendMsg(scope.row)" v-if="scope.row.isAuditing == 0">发送短信 </span>
          <span v-if="scope.row.isAuditing == 0">|</span>
          <span class="pointer" @click="revise(scope.row)" v-if="scope.row.isAuditing != 0">修改 | </span>
          <span class="text-red pointer" @click="deleteRow(scope.row,scope.$index)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="block mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
    <creat v-if="show" @closeComponent='close' :data='reviseData'></creat>
    <send v-if="sendShow" @closeSends='closeSend' :sendData="sendData"></send>
  </div>
</template>
<script>
import tips from '../../components/message/tips'
import creat from '../../components/message/creatMessage'
import send from '../../components/message/send'
import api from '../../server/api.js'
export default {
  name: "creatMessage",
  data(){
    return{
      pageSize: 10,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      messageData: [],
      show: false,
      reviseData: null,
      sendShow: false,
      sendData: null,
    };
  },
  created(){
    this.getMessageList();
  },
  methods: {
    getMessageList(){//获取短信模板列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        // "userName": 
        // "mouldSign": 
        // "mouldName": 
        // "mouldContent": 
        // isPublic:
        // isAuditing:
      }
      api.getSmsMouldList({data:data}).then(res => {
        this.messageData = res.data.resultList;
        this.total = res.data.count;
      })
    },
    creatMessage(){//创建短信模板
      this.reviseData = null;
      this.show = true;
    },
    revise(row){//修改短信模板
      this.reviseData = row;
      this.show = true;
    },
    sendMsg(row){
      this.sendShow = true;
      this.sendData = row;
    },
    deleteRow(row,index){//删除模板
      this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arr = [];
        arr[0] = row.mouldSign
        api.delMessage({data:{"mouldSignList": arr}}).then(res =>{
          if(res.status == 'success'){
            this.$message.success(res.msg);
            this.messageData.splice(index,1)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    close(flag){//关闭创建模板
      this.show = false;
      if(flag){
        this.getMessageList();
      }
    },
    closeSend(){
      this.sendShow = false;
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getMessageList();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getMessageList();
    },
  },
  components: {
    tips,creat,send
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/message/messageList.vue